/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.appusers.rpc.UsersRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type AppUsersError = {
  errorType: AppUsersErrorType;
  context: Default<Record<string, string>>;
  unappliedRequestedChanges?: UnappliedRequestedChanges;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type AppUsersErrorType =
  | 'PORTAL_ID_NOT_PROVIDED'
  | 'USER_ID_NOT_PROVIDED'
  | 'PERMISSION_SET_NOT_FOUND'
  | 'VALIDATION_ERROR'
  | 'INVALID_SEAT_COMBINATION'
  | 'INVALID_VIRTUAL_USER'
  | 'ROLE_NOT_AVAILABLE_TO_HUB'
  | 'ROLE_NOT_ASSIGNABLE_TO_SEAT'
  | 'USER_ID_NOT_FOUND'
  | 'INVALID_SEAT_NAME'
  | 'NOT_ALLOWED_TO_MODIFY_CRITICAL_ROLE'
  | 'ROLE_NOT_ALLOWED'
  | 'CANNOT_MODIFY_MAM_VIRTUAL_USER'
  | 'CANNOT_MODIFY_AI_AGENT_USER'
  | 'USER_DOESNT_HAVE_PARENT_ROLE'
  | 'INVALID_STARTER_LEGACY_COMBO'
  | 'INVALID_CRM_PERMISSION_CONFIGURATION'
  | 'INVALID_PARTNER_SEAT_ASSIGNMENT'
  | 'INVALID_HUBSPOTTER_SEAT_ASSIGNMENT'
  | 'INVALID_AGENT_SEAT_ASSIGNMENT'
  | 'PORTAL_LOCK_CONTENTION'
  | 'CHECKOUT_REQUIRED'
  | 'REQUEST_NOT_FULLY_SATISFIED'
  | 'UNKNOWN'
  | unhandledEnumCase;

export type ChangeExpectation =
  | 'EXPECTED_PRESENT'
  | 'EXPECTED_ABSENT'
  | unhandledEnumCase;

export type CrmObjectAccessLevel =
  | 'NONE'
  | 'OWNED'
  | 'TEAM_OWNED'
  | 'OWNED_AND_UNASSIGNED'
  | 'TEAM_OWNED_AND_UNASSIGNED'
  | 'ALL'
  | unhandledEnumCase;

export type CrmObjectAction =
  | 'VIEW'
  | 'EDIT'
  | 'DELETE'
  | 'MERGE'
  | 'COMMUNICATE'
  | 'CREATE'
  | unhandledEnumCase;

export type CrmObjectPermissionAssignment = {
  objectTypeId: string;
  action: CrmObjectAction;
  access: CrmObjectAccessLevel;
};

export type UnappliedCrmObjectPermissionChange = {
  value: CrmObjectPermissionAssignment;
  expectation: ChangeExpectation;
};

export type UnappliedPermissionSetChange = {
  value: number;
  expectation: ChangeExpectation;
};

export type UnappliedRequestedChanges = {
  changesByUser: Default<Record<string, UserUnappliedChanges>>;
};

export type UnappliedRoleChange = {
  value: string;
  expectation: ChangeExpectation;
};

export type UnappliedSeatChange = {
  value: string;
  expectation: ChangeExpectation;
};

/**
 * One user's slice of {@link UnappliedRequestedChanges#getChangesByUser()}.
 */
export type UserUnappliedChanges = {
  roles: Default<UnappliedRoleChange[]>;
  seats: Default<UnappliedSeatChange[]>;
  permissionSets: Default<UnappliedPermissionSetChange[]>;
  crmObjectPermissions: Default<UnappliedCrmObjectPermissionChange[]>;
};

export type AddUserBulkRequest = {
  users: Default<UserEggDto[]>;
  roleNames: Default<string[]>;
  seatNames: Default<string[]>;
  teamId?: number;
  secondaryTeamIds: Default<number[]>;
  permissionSetIds: Default<number[]>;
  presetId?: number;
  sendWelcomeEmail: Default<boolean>;
  sendSlackInvite: Default<boolean>;
  forceWelcomeEmail: Default<boolean>;
  customMessage?: string;
};

export type AddUserBulkResponse = { users: Default<FullUserInformation[]> };

export type FilterOutInvisibleUsersRequest = { userIds: Default<number[]> };

export type FilterOutInvisibleUsersResponse = {
  portalId: number;
  userIds: Default<number[]>;
};

export type FullUserInformation = {
  id: number;
  email: string;
  roleNames: Default<string[]>;
  seatNames: Default<string[]>;
  firstName: Default<string>;
  lastName: Default<string>;
  permissionSetIds: Default<number[]>;
  teamId?: number;
  expiresAt?: number;
  recentActivityAt?: number;
  secondaryTeamIds: Default<number[]>;
  presetId?: number;
  scim: Default<boolean>;
  pending: Default<boolean>;
  partner: Default<boolean>;
  jita: Default<boolean>;
  emailSent?: boolean;
  emailBounced: Default<boolean>;
};

export type GetUserIdsOnHubByRoleIdRequest = {
  roleId: number;
  includePending: Default<boolean>;
  includeInactive: Default<boolean>;
};

export type GetUserIdsOnHubByRoleIdResponse = {
  portalId: number;
  userIds: Default<number[]>;
};

export type GetUsersByIdsRequest = { userIds: Default<number[]> };

export type GetUsersByIdsResponse = { users: Default<FullUserInformation[]> };

export type RolesAndSeatsDto = {
  roleNames: Default<string[]>;
  seatNames: Default<string[]>;
};

export type SetUserPermissionsAndSeatsRequest = {
  rolesAndSeatsByUserId: Default<Record<string, RolesAndSeatsDto>>;
};

export type SetUserPermissionsAndSeatsResponse = {
  rolesAndSeatsByUserId: Default<Record<string, RolesAndSeatsDto>>;
};

export type SetUserPermissionsRequest = {
  rolesByUserId: Default<Record<string, string[]>>;
};

export type SetUserPermissionsResponse = {
  rolesByUserId: Default<Record<string, string[]>>;
};

export type UserEggDto = {
  email: string;
  roleNames: Default<string[]>;
  seatNames: Default<string[]>;
  firstName: Default<string>;
  lastName: Default<string>;
  permissionSetIds: Default<number[]>;
};

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type GetUserIdsOnHubByRoleIdAndPendingStatusRequestType =
  Requestify<GetUserIdsOnHubByRoleIdRequest>;
export type GetUserIdsOnHubByRoleIdAndPendingStatusResponseType =
  GetUserIdsOnHubByRoleIdResponse;
export type GetUserIdsOnHubByRoleIdAndPendingStatusErrorType = AppUsersError &
  HubspotMetadata;
export const getUserIdsOnHubByRoleIdAndPendingStatusRpc: ChirpAvroRpcDetails<
  GetUserIdsOnHubByRoleIdAndPendingStatusRequestType,
  GetUserIdsOnHubByRoleIdAndPendingStatusResponseType,
  GetUserIdsOnHubByRoleIdAndPendingStatusErrorType,
  false
> = {
  serviceName: 'com.hubspot.appusers.rpc.UsersRpc',
  rpcName: 'getUserIdsOnHubByRoleIdAndPendingStatus',
  auth: 'app',
  fingerprint: 'sPR9EE1FPIgBU2e0akw6AVcYGAbSNxd0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type FilterOutInvisibleUsersRequestType =
  Requestify<FilterOutInvisibleUsersRequest>;
export type FilterOutInvisibleUsersResponseType =
  FilterOutInvisibleUsersResponse;
export type FilterOutInvisibleUsersErrorType = AppUsersError & HubspotMetadata;
export const filterOutInvisibleUsersRpc: ChirpAvroRpcDetails<
  FilterOutInvisibleUsersRequestType,
  FilterOutInvisibleUsersResponseType,
  FilterOutInvisibleUsersErrorType,
  false
> = {
  serviceName: 'com.hubspot.appusers.rpc.UsersRpc',
  rpcName: 'filterOutInvisibleUsers',
  auth: 'app',
  fingerprint: 'z54Q9us7gedyyGwM-v7ZvVcYGAbSNxd0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetUsersByIdsRequestType = Requestify<GetUsersByIdsRequest>;
export type GetUsersByIdsResponseType = GetUsersByIdsResponse;
export type GetUsersByIdsErrorType = AppUsersError & HubspotMetadata;
export const getUsersByIdsRpc: ChirpAvroRpcDetails<
  GetUsersByIdsRequestType,
  GetUsersByIdsResponseType,
  GetUsersByIdsErrorType,
  false
> = {
  serviceName: 'com.hubspot.appusers.rpc.UsersRpc',
  rpcName: 'getUsersByIds',
  auth: 'app',
  fingerprint: '2zwwN0u_84e7bEiN-TP8SlcYGAbSNxd0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SetUserPermissionsRequestType =
  Requestify<SetUserPermissionsRequest>;
export type SetUserPermissionsResponseType = SetUserPermissionsResponse;
export type SetUserPermissionsErrorType = AppUsersError & HubspotMetadata;
export const setUserPermissionsRpc: ChirpAvroRpcDetails<
  SetUserPermissionsRequestType,
  SetUserPermissionsResponseType,
  SetUserPermissionsErrorType,
  false
> = {
  serviceName: 'com.hubspot.appusers.rpc.UsersRpc',
  rpcName: 'setUserPermissions',
  auth: 'app',
  fingerprint: 'rRqFJl3z6U8cP0Fcwuzm6FcYGAbSNxd0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SetUserPermissionsAndSeatsRequestType =
  Requestify<SetUserPermissionsAndSeatsRequest>;
export type SetUserPermissionsAndSeatsResponseType =
  SetUserPermissionsAndSeatsResponse;
export type SetUserPermissionsAndSeatsErrorType = AppUsersError &
  HubspotMetadata;
export const setUserPermissionsAndSeatsRpc: ChirpAvroRpcDetails<
  SetUserPermissionsAndSeatsRequestType,
  SetUserPermissionsAndSeatsResponseType,
  SetUserPermissionsAndSeatsErrorType,
  false
> = {
  serviceName: 'com.hubspot.appusers.rpc.UsersRpc',
  rpcName: 'setUserPermissionsAndSeats',
  auth: 'app',
  fingerprint: 'LJfIKn4X6sLM3mKaBBaHTFcYGAbSNxd0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type AddUserBulkRequestType = Requestify<AddUserBulkRequest>;
export type AddUserBulkResponseType = AddUserBulkResponse;
export type AddUserBulkErrorType = AppUsersError & HubspotMetadata;
export const addUserBulkRpc: ChirpAvroRpcDetails<
  AddUserBulkRequestType,
  AddUserBulkResponseType,
  AddUserBulkErrorType,
  false
> = {
  serviceName: 'com.hubspot.appusers.rpc.UsersRpc',
  rpcName: 'addUserBulk',
  auth: 'app',
  fingerprint: '17GGuAH-iuARMdcRdTM49VcYGAbSNxd0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
